/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
import { AuthActionTypes } from '../store/auth/action-types';
import { getActiveError } from '../store/error/selectors';
import { FlowActionTypes } from '../store/flow/action-types';
import { getCurrentStep } from '../store/flow/selectors';
import { TrackingActionTypes } from '../store/tracking/action-types';
import { setupRecaptcha } from './setupRecaptcha';
import { generateRecaptchaToken } from './utils/generateRecaptchaToken';
let installed = false;

const refreshToken = store => {
  const state = store.getState();
  const currentStep = getCurrentStep(state);
  const activeError = getActiveError(state);
  const currentStepOrActiveError = currentStep || activeError;

  if (currentStepOrActiveError) {
    store.dispatch(generateRecaptchaToken(currentStepOrActiveError));
  }
};

export const RecaptchaMiddleware = store => next => action => {
  if (installed) {
    if (action.type === TrackingActionTypes.StepView) {
      refreshToken(store);
    }
  } else {
    if (action.type === FlowActionTypes.StepCompleted || action.type === TrackingActionTypes.VerifyIdentityCompleted || action.type === AuthActionTypes.ClickCreateNewAccountSameUser) {
      setupRecaptcha().then(() => {
        installed = true;
        refreshToken(store);
      });
    }
  }

  return next(action);
};